// extracted by mini-css-extract-plugin
export default {"container":"mG-z","header":"nG-z","details":"oG-z","link":"pG-z"};